/**
 * Desktop shell — FEST-PHASE-1.0.B.
 *
 * Header + Gridstack canvas with two cubes (Pipeline / Closed Sales) +
 * an editor-sheet overlay host that mounts the EditorSheet when a
 * conversation is being edited.
 */
import { html, render } from "lit-html";
import { renderHeader }      from "./components/Header";
import { renderEditorSheet } from "./components/EditorSheet";
import { renderMobilePreviewCube } from "./components/MobilePreviewCube";
import { store }             from "./data/store";
import { layoutManager }     from "./layout/LayoutManager";
import { initNotifications } from "./utils/notifications";

let rootEl: HTMLElement | null = null;
let gridMounted = false;
let editorHostEl: HTMLElement | null = null;

export function renderApp(root: HTMLElement): void {
  rootEl = root;
  store.subscribe(paint);
  store.start();
  paint();

  editorHostEl = document.createElement("div");
  editorHostEl.id = "editor-sheet-host";
  document.body.appendChild(editorHostEl);

  initNotifications();
}

function paint(): void {
  if (!rootEl) return;
  render(template(), rootEl);

  const gridHost = rootEl.querySelector(".grid-canvas") as HTMLElement | null;
  if (gridHost && !gridMounted) {
    layoutManager.mount(gridHost);
    gridMounted = true;
  }
  if (gridMounted) layoutManager.paintAll();

  if (editorHostEl) render(renderEditorSheet(store.state), editorHostEl);
}

function template() {
  const collapsed = store.state.previewCollapsed;
  return html`
    <div class="shell ${collapsed ? "shell--rail-collapsed" : ""}">
      ${renderHeader(store.state)}
      <div class="shell__main">
        <div class="grid-canvas"></div>
        <aside class="shell__rail">
          ${renderMobilePreviewCube(store.state)}
        </aside>
      </div>
    </div>
  `;
}
